import Bowser from "bowser";
import Splide from "@splidejs/splide";
import * as AOS from "aos";
// import MicroModal from "micromodal";
import * as DOMPurify from "dompurify";
import Typewriter from "typewriter-effect/dist/core";
import "waypoints/lib/noframework.waypoints.min";
import { CountUp } from "countup.js/dist/countUp.min.js";



// AOS
AOS.init({
  offset: 100,
  duration: 600,
  easing: "ease-in",
  anchorPlacement: "top-center",
  once: true,
  disable: "mobile"
});

// MicroModal
// MicroModal.init({
//   onShow: function() {
//     document.querySelector("html").classList.add("locked");
//   },
//   onClose: function() {
//     document.querySelector("html").classList.remove("locked");
//   }
// });

jQuery(document).ready(function($) {
  // Inside of this function, $() will work as an alias for jQuery()
  // and other libraries also using $ will not be accessible under this shortcut
  // https://codex.wordpress.org/Function_Reference/wp_enqueue_script#jQuery_noConflict_Wrappers

  // Touch Device Detection
  var isTouchDevice = "ontouchstart" in document.documentElement;
  if (isTouchDevice) {
    $("body").removeClass("no-touch");
    $("body").addClass("touch");
  }

  // Browser detection via Bowser (https://github.com/lancedikson/bowser) - add detection as needed
  const userBrowser = Bowser.getParser(window.navigator.userAgent);
  const browser = userBrowser.getBrowser();

  if (browser.name === "Internet Explorer" && browser.version == "11.0") {
    $("body").addClass("ie-11");
  } else if (browser.name === "Safari") {
    $("body").addClass("safari");
  }

  // Menu functions
  function toggleMenu(icon, menu) {
    $("html").toggleClass("locked");
    $("body").toggleClass("locked masked");

    icon.toggleClass("active");
    menu.slideToggle();
  }

  function closeMenu(icon, menu) {
    if( menu.css("display") == "block" ) {
      $("html").removeClass("locked");
      $("body").removeClass("locked masked");
    }

    icon.removeClass("active");
    menu.slideUp();
  }

  // Main menu function
  $(".menu-icon").on("click", function() {
    toggleMenu($(this), $(".nav--mobile"));
  });

  // Close menu on desktop
  $(window).on("resize", function() {
    if( $(window).width() > 1024 ) {
      closeMenu($(".menu-icon"), $(".nav--mobile"));
    }
  });

  // Close menu on outside click
  $(document).on("click", function(e) {
    if( !$(e.target).closest(".site-header").length ) {
      closeMenu($(".menu-icon"), $(".nav--mobile"));
    }
  });

  // Close menu on ESC key 
  $(document).on("keyup", function(e) {
    if( e.which == 27) {
      closeMenu($(".menu-icon"), $(".nav--mobile"));
    }
  });

  // Mobile menu sub-menu toggle
  $(".nav--mobile .menu-item-has-children > a").on("click", function(e) {
    e.preventDefault();

    $(this).siblings(".sub-menu").slideToggle();
    $(this).toggleClass("active");
  });

  // Dropdowns
  $(".dropdown__parent").on("click", function() {
    $(this).toggleClass("open");
    $(this).siblings(".dropdown__menu").slideToggle();
  });
  
  $(".dropdown__parent").on("keyup", function(e) {
    // Enter key
    if( e.which == 13) {
      $(this).toggleClass("open");
      $(this).siblings(".dropdown__menu").slideToggle();
    }
  
    // Esc key
    if( e.which == 27) {
      $(this).removeClass("open");
      $(this).siblings(".dropdown__menu").slideUp();
    }
  });
  
  // Close dropdown on selection
  $(".dropdown__menu a").on("click", function() {
    $(this).parents(".dropdown").find(".dropdown__parent").removeClass("open");
    $(this).parents(".dropdown__menu").slideUp();
  });
  
  // Close dropdowns on outside click
  $(document).on("click", function(e) {
    if(!$(e.target).closest(".dropdown").length) {
      if($(".dropdown__menu").css("display") === "block") {
        $(".dropdown__parent").removeClass("open");
        $(".dropdown__menu").slideUp();
      }
    }
  });

  // Typewriter text 
  if( $(".typewriter").length ) {
    $(".typewriter").each(function() {
      let phrases = $(this).attr("data-phrases").split(", "),
        count = phrases.length,
        typewriter;
      
      // Only loop if more than 1 phrase
      if( count > 1 ) {

        typewriter = new Typewriter(this, {
          loop: true,
          delay: 50,
          autoStart: true,
          strings: phrases,
        });

        typewriter.start();

      } else {

        typewriter = new Typewriter(this, {
          delay: 50,
        }).typeString(phrases[0]).start();
      }

    });
  }

  // Form Label Animation
  $(".gform_wrapper form .animated").find("input, select, textarea").on("focusin", function() {
  	$(this).parents(".animated").children("label").addClass("active-position active-weight active-color");

  	// Off focus
  	$(".gform_wrapper form .animated").find("input, select, textarea").on("focusout", function() {
  		if( $(this).val() !== "" ) { // Remove active weight and keep raised position if input has content
  			$(this).parents(".animated").children("label").removeClass("active-weight");
  		} else { // Else remove both weight and raised position
  			$(this).parents(".animated").children("label").removeClass("active-position active-weight active-color");
  		}
  	});
  });

  // Slider section (SplideJS)
  if( $(".slider-section__slider").length ) {
    $(".slider-section__slider").each(function() {
      new Splide(this, {
        type: "loop",
        perPage: 3,
        autoplay: true,
        interval: 2000,          // ⬅️ 2 seconds per slide
        pauseOnHover: true,      // ⬅️ pause on hover
        pauseOnFocus: true,
        pagination: false,
        padding    : { left: "0", right: "15.5%" },
        breakpoints: {
          1199: {
            perPage: 3,
            padding    : { left: "0", right: "15%" },
          },
          1023: {
            perPage: 1,
            padding    : { left: "0", right: "32%" },
          },
          575: {
            perPage: 1,
            padding    : { left: "0", right: "15%" },
          }
          
        }
      }).mount();
    });
  }

  // Logo Slider section (SplideJS)
  if( $(".logo-slider-section__slider").length ) {
    $(".logo-slider-section__slider").each(function() {
      new Splide(this, {
        type: "loop",
        arrows: false,
        autoplay: true,
        perPage: 5,
        gap: "20px",
        pagination: false,
        breakpoints: {
          1280: {
            perPage: 4
          },
          1024: {
            perPage: 3
          },
          767: {
            perPage: 3
          },
          575: {
            perPage: 2
          }
        }
      }).mount();
    });
  }

  // Card Grid animation 
  $(".card-grid button").on("click", function() {
    let col = $(this).parents(".col");

    // Close other cards
    if( col.siblings(".col.open").length ) {
      col.siblings(".col.open").removeClass("open");
    }    

    col.toggleClass("open");
  });

  // Stats row animation 
  const counterSections = [
    ".numbers-stats",
    ".statistic_row",
    ".two-column-content"
  ];

  counterSections.forEach(function(section) {

    $(`${section} .number`).each(function() {

      const stat = this;
      const number = $(this).attr("data-number");

      const countUp = new CountUp(stat, number, {
        duration: number < 50 ? 2 : 4, // small numbers slower
        startVal: 0,
        decimalPlaces: 2,
        // Overriding formatting to drop unnecessary trailing zeros
        formattingFn: (n) => {
          // Keeps whole numbers as they are, and limits decimals to a maximum of 2 places
          return n.toLocaleString(undefined, { 
            minimumFractionDigits: 0, 
            maximumFractionDigits: 2 
          });
        }
      });

      // eslint-disable-next-line
    new Waypoint({
        element: $(this).closest(section)[0],
        handler: function() {

          if (!countUp.error) {
            countUp.start();
            this.destroy();
          } else {
            console.error(countUp.error);
          }

        },
        offset: "80%"
      });

    });

  });

  // Accordions section 
  $(".accordion__header").on("click", function() {
    // Close other accordions
    $(this).parents(".accordions-section").find(".accordion__header").not(this).find("i").removeClass("fa-minus").addClass("fa-plus");
    $(this).parents(".accordions-section").find(".accordion__header").not(this).siblings(".accordion__content").slideUp();

    // Toggle this one
    if( $(this).find("i").hasClass("fa-plus") ) {
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
    } else {
      $(this).find("i").removeClass("fa-minus").addClass("fa-plus");
    }
    
    $(this).siblings(".accordion__content").slideToggle();
  });

  // Load more - main ajax function 
  function loadPosts(cat, tag, paged, total) {
    // Show loading animation
    $(".post-list-section .loading-animation").show();

    // Look for/load new posts
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      dataType: "json",
      data: {
        action: "f1_advanced_search",
        cat: cat,
        tag: tag,
        paged: paged,
      },
      success: function (res) {
        if (res.html != null) {
          $(".post-list-section__list").append(res.html);
        } else {
          $(".post-list-section__list").html("<p>No more posts have been found.</p>");
        }
      },
      complete: function () {
        // Update page of next load
        paged++; 
        $(".post-list-section__list").attr("data-page", paged);

        // Hide loading animation
        $(".post-list-section .loading-animation").hide();

        // If we've loaded all posts, hide load button and show message
        if( paged > total ) {
          $(".post-list-section #load-more").hide();

          $(".post-list-section__load").html("<p>All posts have been loaded.</p>");
        }
      }
    });
  }

  // Load more - click 
  $("#load-more").on("click", function() {
    let list = $(this).parents(".post-list-section").find(".post-list-section__list"),
      cat = list.attr("data-cat") ? list.attr("data-cat") : null,
      tag = list.attr("data-tag") ? list.attr("data-tag") : null,
      paged = list.attr("data-page") ? list.attr("data-page") : 2,
      total = list.attr("data-total-pages");

    loadPosts(cat, tag, paged, total); 
  });

  // Case studies Load more - main ajax function 
  function loadPostsCaseStudies(paged, total) {
    // Show loading animation
    $(".case-studies-list .loading-animation").show();

    // Look for/load new posts
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      dataType: "json",
      data: {
        action: "case_studies_advanced_search",
        paged: paged,
      },
      success: function (res) {
        if (res.html != null) {
          $(".case-studies-list__columns").append(res.html);
        } else {
          $(".case-studies-list__columns").html("<p>No more case studies have been found.</p>");
        }
      },
      complete: function () {
        // Update page of next load
        paged++; 
        $(".post-list-section__list").attr("data-page", paged);

        // Hide loading animation
        $(".case-studies-list .loading-animation").hide();

        // If we've loaded all posts, hide load button and show message
        if( paged > total ) {
          $(".case-studies-list #case-stuides-load-more").hide();

          $(".case-studies-list__load").html("<p>Case Studies have been loaded.</p>");
        }
      }
    });
  }

  // Load more - click 
  $("#case-stuides-load-more").on("click", function() {
    let list = $(this).parents(".case-studies-list").find(".case-studies-list__columns"),
      paged = list.attr("data-page") ? list.attr("data-page") : 2,
      total = list.attr("data-total-pages");

    loadPostsCaseStudies(paged, total); 
  });

  // Smooth anchor link scrolling 
  $("a[href*=\\#]").on("click", function (e) {
    let slug = this.href.split("#")[1].replace("#", "");

    // Only if no matching modal
    if( !$(".modal#modal-" + slug).length && $(".anchor#" + slug).length ) {
      e.preventDefault();
      if(this.pathname === window.location.pathname) {
        // Store hash
        let hash = this.hash;
  
        $("html, body").animate({
          scrollTop: $(hash).offset().top,
        }, 800, function(){
  
          window.location.hash = hash;
        });
      }
    }
  });

  // Trigger matching modal (if there) when hash 
  // if( window.location.hash) {
  //   let hash = window.location.hash.replace("#", "");

  //   if( $(".modal#modal-" + hash).length ) {
  //     MicroModal.show("modal-" + hash);
  //   }
  // }

  // Custom add to cart form with quantity param 
  // Pass variable to query string
  $("form.custom-add-to-cart").on("submit", function(e) {
    e.preventDefault();

    let data = $(this).find(":input"),
      qty = DOMPurify.sanitize(data[0].value),
      product = DOMPurify.sanitize(data[1].value),
      cart = DOMPurify.sanitize(data[2].value);

    let newUrl = `${cart}?add-to-cart=${product}&quantity=${qty}`;

    window.location.href = newUrl;
  });

  function updateSplitAlignment() {

    const container = document.querySelector(".site-footer__info");

    if (!container) return;

    const containerLeft =
    container.getBoundingClientRect().left;

    const containerStyle =
    getComputedStyle(container);

    const containerPadding =
    parseFloat(containerStyle.paddingLeft);

    const extraSpace = -10;

    const finalOffset =
    containerLeft +
    containerPadding +
    extraSpace;

    // Add dynamic offset only on this class
    document.querySelectorAll(".full-width-split").forEach((item) => {
      item.style.setProperty(
        "--dynamic-offset",
        `${finalOffset}px`
      );
    });

  }

  updateSplitAlignment();

  window.addEventListener(
    "resize",
    updateSplitAlignment
  );


  const rings = document.querySelectorAll(".progress-ring");

  rings.forEach((svg) => {

    const arc = svg.querySelector(".arc");
    const value = svg.querySelector(".value");

    const radius = 134.5;

    const circumference =
        2 * Math.PI * radius;

    const target =
        parseInt(svg.getAttribute("aria-valuenow"));

    // Initial hidden state
    arc.style.strokeDasharray =
        circumference;

    arc.style.strokeDashoffset =
        circumference;

    function animateRing(duration = 1500) {

      const start =
          performance.now();

      function animate(currentTime) {

        const progress = Math.min(
          (currentTime - start) / duration,
          1
        );

        // smooth easing
        const ease =
            1 - Math.pow(1 - progress, 3);

        // animated value
        const currentValue =
            Math.round(ease * target);

        // animated stroke
        const offset =
            circumference -
            ease * target / 100 * circumference;

        arc.style.strokeDashoffset =
            offset;

        // animated text
        value.textContent =
            currentValue + "%";

        if (progress < 1) {
          requestAnimationFrame(animate);
        }

      }

      requestAnimationFrame(animate);

    }

    // Scroll visible animation
    const observer =
        new IntersectionObserver(

          (entries, observer) => {

            entries.forEach((entry) => {

              if (entry.isIntersecting) {

                animateRing();

                // Run only once
                observer.unobserve(entry.target);

              }

            });

          },

          {
            threshold: 0.4
          }

        );

    observer.observe(svg);

  });
  
});
